import { render, staticRenderFns } from "./NotificacoesColaboradores.vue?vue&type=template&id=1b49ef79&scoped=true"
import script from "./NotificacoesColaboradores.vue?vue&type=script&lang=js"
export * from "./NotificacoesColaboradores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b49ef79",
  null
  
)

export default component.exports